import { SPA_CLIENT_IDS, entra } from './entra';

export const environment = {
  name: 'Test',
  baseUrl: 'https://test-api.stockholmstag.sj.se/public/solvind-dashboard',
  auth: entra(SPA_CLIENT_IDS.test),
};
